import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const HeadLogo = ({ settingsData }) => {
  const [logoSrc, setLogoSrc] = useState("");

  // Utility function to retrieve a cookie value by name
  const getCookie = (name) => {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? match[2] : null;
  };

  useEffect(() => {
     // Try to get the mini logo from cookie
    const cookieLogo = getCookie("mini_logo");
    if (cookieLogo) {
      // If found in cookies, use it as the logo source
      setLogoSrc(process.env.REACT_APP_IMAGE_PATH + "setting/" + cookieLogo);
    } else if (settingsData?.mini_logo) {
      // If not in cookies but available in settingsData, set the cookie
      document.cookie = `mini_logo=${settingsData.mini_logo}; path=/; max-age=604800`; // valid for 7 days
      // And use it as the logo source
      setLogoSrc(
        process.env.REACT_APP_IMAGE_PATH + "setting/" + settingsData.mini_logo
      );
    }
  }, [settingsData]);

  return (
    <div >
      <Link to="/">
        <img src={logoSrc} alt="SiddhiAananta" />
      </Link>
    </div>
  );
};

export default HeadLogo;
